/**
 * @file index.js
 * @description
 * Entry point for the React application.
 * Renders the App component into the root DOM node.
 * Includes Vercel Analytics and web vitals reporting.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './style.css';
import './theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Analytics } from '@vercel/analytics/react'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Analytics /> 
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
